import { useEffect, useState } from 'react'
import { useStore } from 'store';
import { hideLoader, showLoader } from 'store/actions/commons';
import { BASE_PATH_API, NO_IMAGE_DEFAULT } from 'constants/env';
import { getSizeColorAdapter } from 'newFunctions/sizeColor_Adapter';
import useUpdateGifts from './useUpdateGifts';
import useDeleteGifts from './useDeleteGifts';


const formPayloadProducts = ({actualData, payload}) =>{

    const reduceMap = (giftsArray) => {
        let ArraySaneado
        if(giftsArray?.length >= 1){
            ArraySaneado = giftsArray.map(item => {
                const obj = {
                    children_sku: item?.children_sku,
                    ean: item?.ean,
                    sku: item?.sku,
                    variant_id: item?.variant_id,
                    product_id: item?.product_id,
                    quantity: item?.amount || item?.quantity
                }
                return obj
            })
        }
        return ArraySaneado
    }

    let gifts
    if(actualData?.gifts?.length > 0){
        gifts = reduceMap(actualData?.gifts)
    }else{
        gifts = []
    }

    const newGift = reduceMap(payload)
    const index = gifts?.findIndex(item => (item?.product_id === newGift[0]?.product_id) && (item?.children_sku === newGift[0]?.children_sku) );

    let giftsReturn
    if(index !== -1){
        giftsReturn = gifts?.map(item => {
            const matchedItem = newGift?.find(item2 => (item?.product_id === item2?.product_id) && (item?.children_sku === item2?.children_sku))
            return matchedItem ? { ...item, ...matchedItem } : item;
        })
    }else{
        giftsReturn =  [...gifts, newGift[0]]
    }
    return {gifts: giftsReturn}
}


const useProductCard = ({item}) => {
    
    const Domain = BASE_PATH_API
    const [ giftTable, dispatch ] = useStore((state) => state.giftTable.giftTable)

    // console.log('useProductCard giftTable: ',giftTable)
    const { setResponseEvents } = useUpdateGifts()
    const { setRemoveItem } = useDeleteGifts()

    const image = item?.pictures ? item?.pictures[0]?.source.indexOf('?') === -1 ? `${item?.pictures[0]?.source}?scale=250` :`${item?.pictures[0]?.source}&scale=250` : NO_IMAGE_DEFAULT


    /* esto llevara el hook */
    const [ productTC, setProductTC ] = useState({})
    const [ addGiftProd, setAddGiftProd ] = useState(null)
    const [ addMore, setAddMore ] = useState(null)
    const [ removeGift, setRemoveGift ] = useState(null)
    const [ emptyGift, setEmptyGift ] = useState(null)
    const [ IsGiftTC, setIsGiftTC ] = useState(null)
    const [ amount, setAmount ] = useState(null)
    const [ idEvent, setIdEvent ] = useState(null)

    const eventActualGifts = async () => {
        const numEvent = giftTable?.type?.id
        setIdEvent(giftTable?.id)
        await fetch(`${Domain}/gift-table/v1/event/${numEvent}`)
        // const data = await response.json()
    }


    const clickModalProduct = async (props) => {
        const {
            productVariant,
            producto,
            showModal
        } = props

        const tallaColor = getSizeColorAdapter(productVariant?.variations)

        const nuevoProdTC = {
            ...productVariant,
            tallaColor
        }

        const productSelectTC  = {
            showModal,
            variants: nuevoProdTC
        }

        const productSelect  = {
            showModal,
            producto
        }
       
        if(productVariant){
            setProductTC(productSelectTC)
        }else{
            setProductTC(productSelect)
        }
    }


    const clickAddProduct = async ({cant = 1}) => {
        
        dispatch(showLoader());
        const giftIdEvent = giftTable?.id
        setIdEvent(giftIdEvent)
        const cantidad = cant ? Number(cant) : Number(1)
        const prod = {
            gifts: [
                {
                    product_id: Number(item?.id),
                    quantity: cantidad,
                    ean: String(item?.ean),
                    sku: String(item?.sku),
                    children_sku: item?.variations?.length >= 1 ? String(item?.variations[0].sku) : null,
                    variant_id: item?.variations?.length >= 1 ? String(item?.variations[0].id) : null,
                }
            ]
        }

        console.log('-------------------')
        console.log('AddProduct - item: ', item)
        console.log('AddProduct - product: ', prod)
        
        const payload = formPayloadProducts({actualData: giftTable, payload: prod?.gifts})
        
        console.log('AddProduct - payload: ', payload)
        console.log('-------------------')

        const header = {
            method: 'PATCH',
            headers: { 'Content-Type':'application/json' },
            body: JSON.stringify(payload)
        }

        if( item?.stock >= 0 ){
            const response = await fetch(`${Domain}/gift-table/v1/gift-table/${giftIdEvent}`,header);
            const data = await response.json();
            setAddGiftProd(data)
        }
    }


    const clickAddProductTC = async (props) => {
        const {
            cant = 1,
            children_sku,
            variant_id
        } = props

        dispatch(showLoader());
        const giftIdEvent = giftTable?.id
        setIdEvent(giftIdEvent)
        const cantidad = cant ? Number(cant) : Number(1)
        const stockVariant = item?.variations.filter(stock => String(stock?.sku) === String(children_sku) )[0].stock

        const prod = {
            gifts: [
                {
                    product_id: Number(item?.id),
                    quantity: cantidad,
                    ean: String(item?.ean),
                    sku: String(item?.sku),
                    children_sku,
                    variant_id
                }
            ]
        }
        const payload = formPayloadProducts({actualData: giftTable, payload: prod?.gifts})
        const header = {
            method: 'PATCH',
            headers: { 'Content-Type':'application/json' },
            body: JSON.stringify(payload)
        }

        if( item?.stock >= 0 || stockVariant >= 1 ){
            const response = await fetch(`${Domain}/gift-table/v1/gift-table/${giftIdEvent}`,header);
            const data = await response.json();
            setAddGiftProd(data)
        }else{
            dispatch(hideLoader());
        }
    }


    const removeProduct = async () =>{
        dispatch(showLoader());
        const giftIdEvent = giftTable?.id
        setIdEvent(giftIdEvent)
        const header = {
            method: 'DELETE',
            headers: { 'Content-Type':'application/json' }
        }

        if( item?.stock >= 0 ){
            await fetch(`${Domain}/gift-table/v1/gift-table/${giftIdEvent}/products?product_id=${item?.id}`,header)
            setRemoveItem(item?.id)
            dispatch(hideLoader());
        }
    }

    
    const sendCant = async (event) =>{
        const valor =  event.target.value
        if(valor === ''){
            setAmount(1)
            setClickCantidad(true)
        }else{
            setAmount(valor)
            setClickCantidad(true)
        }
    }


    const updateCant = async (event) =>{
        const valor =  event.target.value
        if(valor < item?.stock){
            setAmount(valor)
            // console.log('valor: ',valor)
        }else if(valor > item?.stock){
            setAmount(item?.stock)
        }
    }


    const [ clickCantidad, setClickCantidad] = useState(false)
    const moreCant = async () =>{
        if(amount < item?.stock){
            setAmount(amount + 1)
            setClickCantidad(true)
        }
    }
    const minCant = async () =>{
        if(amount > 1){
            setAmount(amount - 1)
            setClickCantidad(true)
        }
    }


    useEffect(()=>{
        if(clickCantidad){
            clickAddProduct({ cant: amount })
            setClickCantidad(false)
        }
    },[clickCantidad])

    useEffect(()=>{
        if(giftTable){
            // console.log('useProductCard giftTable 2: ',giftTable)
            const isGift = giftTable?.gifts?.find(gift => gift?.product_id === item?.id)
            const cantGift = isGift?.amount
            setAddMore(cantGift)
            setRemoveGift(cantGift)
            setAmount(cantGift)
        }
    },[giftTable])

    useEffect(() => {
        if(item){
            dispatch(hideLoader());
            if(item?.stock >= 0){
                setEmptyGift(false)
                if(item?.variations?.length >= 1){
                    setIsGiftTC(true)
                }else{
                    setIsGiftTC(false)
                }
            }
            else{
                setEmptyGift(true)
            }
        }
    },[item])


    const [ successUpdate, setSuccessUpdate ] = useState(false)
    useEffect(() => {
        if(addGiftProd && addGiftProd?.data && addGiftProd?.data?.gifts){
            setResponseEvents(addGiftProd?.data)
            clickModalProduct( {showModal: false} )
            eventActualGifts()
            dispatch(hideLoader());
            setSuccessUpdate(addGiftProd?.data)
        }
    },[addGiftProd])


    const producto = {
        ...item
    }

    return {
        producto,
        image,
        addMore,
        removeGift,
        emptyGift,
        IsGiftTC,
        amount,
        productTC,
        idEvent,
        successUpdate,
        setSuccessUpdate,
        clickAddProduct,
        clickAddProductTC,
        clickModalProduct,
        removeProduct,
        updateCant,
        sendCant,
        moreCant,
        minCant
    }
}

export default useProductCard